export default __webpack_public_path__ + "static/media/empleado.580bc9c1.png";